/**
 * 业务状态枚举
 */
// ========== 通用 ==========
export var OrderStatus;
(function (OrderStatus) {
    OrderStatus["PENDING"] = "PENDING";
    OrderStatus["IN_PROGRESS"] = "IN_PROGRESS";
    OrderStatus["COMPLETED"] = "COMPLETED";
    OrderStatus["CANCELLED"] = "CANCELLED";
})(OrderStatus || (OrderStatus = {}));
export var ApprovalStatus;
(function (ApprovalStatus) {
    ApprovalStatus["DRAFT"] = "DRAFT";
    ApprovalStatus["PENDING"] = "PENDING";
    ApprovalStatus["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    ApprovalStatus["APPROVED"] = "APPROVED";
    ApprovalStatus["REJECTED"] = "REJECTED";
})(ApprovalStatus || (ApprovalStatus = {}));
/**
 * 审批任务运行时状态 (ApprovalTask.status).
 * 跟 ApprovalStatus 区别: 业务单上的状态字段只关心 APPROVED/REJECTED 终态;
 * 任务自身需要 IN_PROGRESS/CANCELLED/COMPLETED 三个引擎用的运行态.
 */
export var ApprovalTaskStatus;
(function (ApprovalTaskStatus) {
    ApprovalTaskStatus["IN_PROGRESS"] = "IN_PROGRESS";
    ApprovalTaskStatus["APPROVED"] = "APPROVED";
    ApprovalTaskStatus["REJECTED"] = "REJECTED";
    ApprovalTaskStatus["CANCELLED"] = "CANCELLED";
    ApprovalTaskStatus["COMPLETED"] = "COMPLETED";
})(ApprovalTaskStatus || (ApprovalTaskStatus = {}));
/** 请假申请状态 (LeaveRequest.status) */
export var LeaveStatus;
(function (LeaveStatus) {
    LeaveStatus["PENDING"] = "PENDING";
    LeaveStatus["APPROVED"] = "APPROVED";
    LeaveStatus["REJECTED"] = "REJECTED";
    LeaveStatus["CANCELLED"] = "CANCELLED";
})(LeaveStatus || (LeaveStatus = {}));
/** 考勤记录状态 (AttendanceRecord.status) */
export var AttendanceRecordStatus;
(function (AttendanceRecordStatus) {
    AttendanceRecordStatus["NORMAL"] = "NORMAL";
    AttendanceRecordStatus["LATE"] = "LATE";
    AttendanceRecordStatus["EARLY_LEAVE"] = "EARLY_LEAVE";
    AttendanceRecordStatus["ABSENT"] = "ABSENT";
    AttendanceRecordStatus["LEAVE"] = "LEAVE";
    AttendanceRecordStatus["HOLIDAY"] = "HOLIDAY";
    AttendanceRecordStatus["OVERTIME"] = "OVERTIME";
})(AttendanceRecordStatus || (AttendanceRecordStatus = {}));
/** 通用实体状态（客户、供应商、资产等） */
export var EntityStatus;
(function (EntityStatus) {
    EntityStatus["ACTIVE"] = "ACTIVE";
    EntityStatus["INACTIVE"] = "INACTIVE";
    EntityStatus["DISPOSED"] = "DISPOSED";
    EntityStatus["FULLY_DEPRECIATED"] = "FULLY_DEPRECIATED";
})(EntityStatus || (EntityStatus = {}));
// ========== MES 生产 ==========
export var BundleStatus;
(function (BundleStatus) {
    BundleStatus["CREATED"] = "CREATED";
    BundleStatus["IN_STOCK"] = "IN_STOCK";
    BundleStatus["OUT_FOR_PROD"] = "OUT_FOR_PROD";
    BundleStatus["IN_PROGRESS"] = "IN_PROGRESS";
    BundleStatus["PROD_COMPLETED"] = "PROD_COMPLETED";
    BundleStatus["QC_DONE"] = "QC_DONE";
    BundleStatus["COMPLETED"] = "COMPLETED";
    BundleStatus["SHIPPED"] = "SHIPPED";
})(BundleStatus || (BundleStatus = {}));
export var DeliveryNoteStatus;
(function (DeliveryNoteStatus) {
    DeliveryNoteStatus["DRAFT"] = "DRAFT";
    DeliveryNoteStatus["CONFIRMED"] = "CONFIRMED";
    DeliveryNoteStatus["PRINTED"] = "PRINTED";
    DeliveryNoteStatus["SHIPPED"] = "SHIPPED";
    DeliveryNoteStatus["VOID"] = "VOID";
})(DeliveryNoteStatus || (DeliveryNoteStatus = {}));
/** 补片记录状态机（人工台账，不走 bundle/工票） */
export var RepairStatus;
(function (RepairStatus) {
    RepairStatus["PENDING"] = "PENDING";
    RepairStatus["ARRIVED"] = "ARRIVED";
    RepairStatus["IN_PRODUCTION"] = "IN_PRODUCTION";
    RepairStatus["FINISHED"] = "FINISHED";
    RepairStatus["SHIPPED"] = "SHIPPED";
    RepairStatus["CANCELLED"] = "CANCELLED";
})(RepairStatus || (RepairStatus = {}));
/** 补片原因 */
export var RepairReason;
(function (RepairReason) {
    RepairReason["DEFECT"] = "DEFECT";
    RepairReason["MISS_PRINT"] = "MISS_PRINT";
    RepairReason["COLOR_OFF"] = "COLOR_OFF";
    RepairReason["DAMAGED"] = "DAMAGED";
    RepairReason["CUSTOMER_COMPLAINT"] = "CUSTOMER_COMPLAINT";
    RepairReason["OTHER"] = "OTHER";
})(RepairReason || (RepairReason = {}));
/** 补片送货单状态 (独立于正单 DeliveryNoteStatus) */
export var RepairDeliveryNoteStatus;
(function (RepairDeliveryNoteStatus) {
    RepairDeliveryNoteStatus["DRAFT"] = "DRAFT";
    RepairDeliveryNoteStatus["CONFIRMED"] = "CONFIRMED";
    RepairDeliveryNoteStatus["SHIPPED"] = "SHIPPED";
    RepairDeliveryNoteStatus["CANCELLED"] = "CANCELLED";
})(RepairDeliveryNoteStatus || (RepairDeliveryNoteStatus = {}));
export var TechReportStatus;
(function (TechReportStatus) {
    TechReportStatus["DRAFT"] = "DRAFT";
    TechReportStatus["PENDING_PM"] = "PENDING_PM";
    TechReportStatus["PENDING_DIRECTOR"] = "PENDING_DIRECTOR";
    TechReportStatus["APPROVED"] = "APPROVED";
    TechReportStatus["REJECTED"] = "REJECTED";
})(TechReportStatus || (TechReportStatus = {}));
export var ScanAction;
(function (ScanAction) {
    ScanAction["START"] = "START";
    ScanAction["END"] = "END";
    ScanAction["PASS"] = "PASS";
    ScanAction["FAIL"] = "FAIL";
    ScanAction["SCAN"] = "SCAN";
    ScanAction["QC_PASS"] = "QC_PASS";
    ScanAction["QC_FAIL"] = "QC_FAIL";
    ScanAction["QC_DEFECT"] = "QC_DEFECT";
})(ScanAction || (ScanAction = {}));
/** 色牢度测试报告状态 */
export var FastnessTestStatus;
(function (FastnessTestStatus) {
    FastnessTestStatus["PENDING"] = "PENDING";
    FastnessTestStatus["IN_PROGRESS"] = "IN_PROGRESS";
    FastnessTestStatus["COMPLETED"] = "COMPLETED";
    FastnessTestStatus["FAILED"] = "FAILED";
})(FastnessTestStatus || (FastnessTestStatus = {}));
/** 色牢度测试项结果 */
export var FastnessTestResult;
(function (FastnessTestResult) {
    FastnessTestResult["PASS"] = "PASS";
    FastnessTestResult["FAIL"] = "FAIL";
})(FastnessTestResult || (FastnessTestResult = {}));
// ========== ERP CRM ==========
export var QuotationStatus;
(function (QuotationStatus) {
    QuotationStatus["DRAFT"] = "DRAFT";
    QuotationStatus["SENT"] = "SENT";
    QuotationStatus["ACCEPTED"] = "ACCEPTED";
    QuotationStatus["CONVERTED"] = "CONVERTED";
    QuotationStatus["EXPIRED"] = "EXPIRED";
    QuotationStatus["REJECTED"] = "REJECTED";
})(QuotationStatus || (QuotationStatus = {}));
export var SalesOrderStatus;
(function (SalesOrderStatus) {
    SalesOrderStatus["DRAFT"] = "DRAFT";
    SalesOrderStatus["CONFIRMED"] = "CONFIRMED";
    SalesOrderStatus["IN_PRODUCTION"] = "IN_PRODUCTION";
    SalesOrderStatus["CREDIT_HOLD"] = "CREDIT_HOLD";
    SalesOrderStatus["PARTIAL"] = "PARTIAL";
    SalesOrderStatus["DELIVERED"] = "DELIVERED";
    SalesOrderStatus["CANCELLED"] = "CANCELLED";
})(SalesOrderStatus || (SalesOrderStatus = {}));
// ========== ERP SRM ==========
export var RequisitionStatus;
(function (RequisitionStatus) {
    RequisitionStatus["DRAFT"] = "DRAFT";
    RequisitionStatus["SUBMITTED"] = "SUBMITTED";
    RequisitionStatus["APPROVED"] = "APPROVED";
    RequisitionStatus["REJECTED"] = "REJECTED";
    RequisitionStatus["CANCELLED"] = "CANCELLED";
    RequisitionStatus["ORDERED"] = "ORDERED";
})(RequisitionStatus || (RequisitionStatus = {}));
export var PurchaseOrderStatus;
(function (PurchaseOrderStatus) {
    PurchaseOrderStatus["DRAFT"] = "DRAFT";
    PurchaseOrderStatus["APPROVED"] = "APPROVED";
    PurchaseOrderStatus["PARTIALLY_RECEIVED"] = "PARTIALLY_RECEIVED";
    PurchaseOrderStatus["RECEIVED"] = "RECEIVED";
    PurchaseOrderStatus["CANCELLED"] = "CANCELLED";
})(PurchaseOrderStatus || (PurchaseOrderStatus = {}));
// ========== ERP 财务 ==========
export var BudgetStatus;
(function (BudgetStatus) {
    BudgetStatus["DRAFT"] = "DRAFT";
    BudgetStatus["ACTIVE"] = "ACTIVE";
    BudgetStatus["CLOSED"] = "CLOSED";
})(BudgetStatus || (BudgetStatus = {}));
export var JournalEntryStatus;
(function (JournalEntryStatus) {
    JournalEntryStatus["DRAFT"] = "DRAFT";
    JournalEntryStatus["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    JournalEntryStatus["APPROVED"] = "APPROVED";
    JournalEntryStatus["REJECTED"] = "REJECTED";
    JournalEntryStatus["POSTED"] = "POSTED";
    JournalEntryStatus["REVERSED"] = "REVERSED";
})(JournalEntryStatus || (JournalEntryStatus = {}));
export var ProvisionStatus;
(function (ProvisionStatus) {
    ProvisionStatus["DRAFT"] = "DRAFT";
    ProvisionStatus["ACTIVE"] = "ACTIVE";
    ProvisionStatus["REVERSED"] = "REVERSED";
    ProvisionStatus["CLOSED"] = "CLOSED";
})(ProvisionStatus || (ProvisionStatus = {}));
export var LeaseStatus;
(function (LeaseStatus) {
    LeaseStatus["ACTIVE"] = "ACTIVE";
    LeaseStatus["MODIFIED"] = "MODIFIED";
    LeaseStatus["EXPIRED"] = "EXPIRED";
    LeaseStatus["TERMINATED"] = "TERMINATED";
})(LeaseStatus || (LeaseStatus = {}));
export var AccountingPeriodStatus;
(function (AccountingPeriodStatus) {
    AccountingPeriodStatus["OPEN"] = "OPEN";
    AccountingPeriodStatus["CLOSED"] = "CLOSED";
})(AccountingPeriodStatus || (AccountingPeriodStatus = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["PENDING"] = "PENDING";
    PaymentStatus["PAID"] = "PAID";
    PaymentStatus["PARTIAL"] = "PARTIAL";
    PaymentStatus["OVERDUE"] = "OVERDUE";
    PaymentStatus["CANCELLED"] = "CANCELLED";
})(PaymentStatus || (PaymentStatus = {}));
export var IntercompanyTxStatus;
(function (IntercompanyTxStatus) {
    IntercompanyTxStatus["PENDING"] = "PENDING";
    IntercompanyTxStatus["CONFIRMED"] = "CONFIRMED";
    IntercompanyTxStatus["ELIMINATED"] = "ELIMINATED";
})(IntercompanyTxStatus || (IntercompanyTxStatus = {}));
export var ConsolidationRunStatus;
(function (ConsolidationRunStatus) {
    ConsolidationRunStatus["DRAFT"] = "DRAFT";
    ConsolidationRunStatus["COMPLETED"] = "COMPLETED";
    ConsolidationRunStatus["PUBLISHED"] = "PUBLISHED";
})(ConsolidationRunStatus || (ConsolidationRunStatus = {}));
export var ConsolidationRunType;
(function (ConsolidationRunType) {
    ConsolidationRunType["MONTHLY"] = "MONTHLY";
    ConsolidationRunType["CUMULATIVE"] = "CUMULATIVE";
})(ConsolidationRunType || (ConsolidationRunType = {}));
export var ProjectStatus;
(function (ProjectStatus) {
    ProjectStatus["PLANNING"] = "PLANNING";
    ProjectStatus["IN_PROGRESS"] = "IN_PROGRESS";
    ProjectStatus["COMPLETED"] = "COMPLETED";
    ProjectStatus["ON_HOLD"] = "ON_HOLD";
    ProjectStatus["CANCELLED"] = "CANCELLED";
})(ProjectStatus || (ProjectStatus = {}));
// ========== ERP HRM ==========
export var EmployeeStatus;
(function (EmployeeStatus) {
    EmployeeStatus["ACTIVE"] = "ACTIVE";
    EmployeeStatus["PROBATION"] = "PROBATION";
    EmployeeStatus["TERMINATED"] = "TERMINATED";
    EmployeeStatus["LEAVE"] = "LEAVE";
})(EmployeeStatus || (EmployeeStatus = {}));
export var AttendanceStatus;
(function (AttendanceStatus) {
    AttendanceStatus["NORMAL"] = "NORMAL";
    AttendanceStatus["LATE"] = "LATE";
    AttendanceStatus["EARLY_LEAVE"] = "EARLY_LEAVE";
    AttendanceStatus["ABSENT"] = "ABSENT";
    AttendanceStatus["LEAVE"] = "LEAVE";
    AttendanceStatus["HOLIDAY"] = "HOLIDAY";
})(AttendanceStatus || (AttendanceStatus = {}));
export var PayrollPeriodStatus;
(function (PayrollPeriodStatus) {
    PayrollPeriodStatus["DRAFT"] = "DRAFT";
    PayrollPeriodStatus["CONFIRMED"] = "CONFIRMED";
    PayrollPeriodStatus["PAID"] = "PAID";
})(PayrollPeriodStatus || (PayrollPeriodStatus = {}));
// ========== ERP OA ==========
export var ContractStatus;
(function (ContractStatus) {
    ContractStatus["DRAFT"] = "DRAFT";
    ContractStatus["ACTIVE"] = "ACTIVE";
    ContractStatus["EXPIRED"] = "EXPIRED";
    ContractStatus["TERMINATED"] = "TERMINATED";
})(ContractStatus || (ContractStatus = {}));
export var MeetingStatus;
(function (MeetingStatus) {
    MeetingStatus["DRAFT"] = "DRAFT";
    MeetingStatus["CONFIRMED"] = "CONFIRMED";
    MeetingStatus["CANCELLED"] = "CANCELLED";
    MeetingStatus["COMPLETED"] = "COMPLETED";
})(MeetingStatus || (MeetingStatus = {}));
export var AnnouncementStatus;
(function (AnnouncementStatus) {
    AnnouncementStatus["DRAFT"] = "DRAFT";
    AnnouncementStatus["PUBLISHED"] = "PUBLISHED";
    AnnouncementStatus["ARCHIVED"] = "ARCHIVED";
})(AnnouncementStatus || (AnnouncementStatus = {}));
// ========== WMS ==========
export var InventoryTransactionType;
(function (InventoryTransactionType) {
    InventoryTransactionType["IN"] = "IN";
    InventoryTransactionType["OUT"] = "OUT";
    InventoryTransactionType["TRANSFER"] = "TRANSFER";
    InventoryTransactionType["ADJUSTMENT"] = "ADJUSTMENT";
})(InventoryTransactionType || (InventoryTransactionType = {}));
